import { Component, Input, Output, EventEmitter } from '@angular/core';
import { PageResponse } from '../page-response';

@Component({
  selector: 'app-paging-v2',
  templateUrl: './paging2.component.html',
  styleUrls: ['./paging2.component.scss']
})

export class Paging2Component {

  @Input() page!: PageResponse;
  @Input() maxVisible = 20;
  @Input() showSizeSelector = true;

  @Output() pageChange = new EventEmitter<number>();
  @Output() sizeChange = new EventEmitter<number>();

  sizes = [10, 15, 20, 50, 5];

  changePage(p: number) {
    if (!this.page) return;
    if (p >= 0 && p < this.page.totalPages) {
      this.pageChange.emit(p);
    }
  }

  get pages(): (number | '...')[] {
    if (!this.page) return [];

    const total = this.page.totalPages;
    const current = this.page.number;
    const delta = Math.floor(this.maxVisible / 2);

    let start = Math.max(0, current - delta);
    let end = Math.min(total - 1, current + delta);

    if (end - start < this.maxVisible - 1) {
      start = Math.max(0, end - this.maxVisible + 1);
    }

    const result: (number | '...')[] = [];

    if (start > 0) {
      result.push(0);
      if (start > 1) result.push('...');
    }

    for (let i = start; i <= end; i++) {
      result.push(i);
    }

    if (end < total - 1) {
      if (end < total - 2) result.push('...');
      result.push(total - 1);
    }

    return result;
  }
  
}
